import React from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import useDateFormat from '../../../../shared/hooks/useDateFormat';

const DetailRow = ({ label, value }) => (
  <Box sx={{ display: 'flex', justifyContent: 'space-between', py: 0.5 }}>
    <Typography variant='body2' color='text.secondary'>
      {label}
    </Typography>
    <Typography variant='body2' fontWeight='medium'>
      {value || '-'}
    </Typography>
  </Box>
);

/**
 * Displays the staged (API) voyage details and its shipments.
 */
const StagingStagedDetails = ({ stagedVoyage }) => {
  const { formatDateTime } = useDateFormat();

  if (!stagedVoyage) return null;

  return (
    <Box sx={{ width: '40%' }}>
      <Card variant='outlined'>
        <CardContent>
          <Typography variant='subtitle1' fontWeight='bold' gutterBottom>
            API Voyage (Staged)
          </Typography>
          <Divider sx={{ mb: 2 }} />
          <DetailRow label='Voyage Number' value={stagedVoyage.voyageNumber} />
          <DetailRow
            label='Ship'
            value={
              stagedVoyage.shipName
                ? `${stagedVoyage.shipName} (${stagedVoyage.imo})`
                : stagedVoyage.imo
            }
          />
          <DetailRow
            label='Departure'
            value={`${stagedVoyage.departurePort} (${stagedVoyage.departureCountry})`}
          />
          <DetailRow
            label='Destination'
            value={`${stagedVoyage.destinationPort} (${stagedVoyage.destinationCountry})`}
          />
          <DetailRow
            label='ETD'
            value={formatDateTime(stagedVoyage.actualETD)}
          />
          <DetailRow
            label='ETA'
            value={formatDateTime(stagedVoyage.actualETA)}
          />
          <DetailRow
            label='Port Operator'
            value={stagedVoyage.portOperatorName}
          />
          <DetailRow
            label='Staged At'
            value={formatDateTime(stagedVoyage.stagedAt)}
          />
          {stagedVoyage.generalRemarks && (
            <DetailRow label='Remarks' value={stagedVoyage.generalRemarks} />
          )}
        </CardContent>
      </Card>

      {/* Staged Shipments */}
      {stagedVoyage.shipments && stagedVoyage.shipments.length > 0 && (
        <Card variant='outlined' sx={{ mt: 2 }}>
          <CardContent>
            <Typography variant='subtitle2' fontWeight='bold' gutterBottom>
              Shipments ({stagedVoyage.shipments.length})
            </Typography>
            <TableContainer>
              <Table size='small'>
                <TableHead>
                  <TableRow>
                    <TableCell>Market</TableCell>
                    <TableCell align='right'>Eff. Shipped</TableCell>
                    <TableCell align='right'>Final Agr.</TableCell>
                    <TableCell align='right'>1st Offer</TableCell>
                    <TableCell align='right'>Adj. PO</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {stagedVoyage.shipments.map((s, i) => (
                    <TableRow key={i}>
                      <TableCell>{s.marketName || s.marketId}</TableCell>
                      <TableCell align='right'>
                        {s.effectiveShipped ?? '-'}
                      </TableCell>
                      <TableCell align='right'>
                        {s.finalAgreement ?? '-'}
                      </TableCell>
                      <TableCell align='right'>
                        {s.firstShippingLineOffer ?? '-'}
                      </TableCell>
                      <TableCell align='right'>
                        {s.adjustedPORequest ?? '-'}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </CardContent>
        </Card>
      )}
    </Box>
  );
};

export default StagingStagedDetails;
